<template>
  <div class="home">
    <div class="top_menus">
      <!-- <div style="display:flex">
        <div class="label_tips">
          <p>
            当前文件:
          </p>
        </div>
        <div class="file_list_menu">
          <van-dropdown-menu>
            <van-dropdown-item v-model="file_id" :options="file_option" @change="changeFile" />
          </van-dropdown-menu>
        </div>
      </div> -->
      <div v-show="!isLoading" style="display:flex;align-items:center; width:50%;margin:0 20px">
        <span style="font-size:14px">{{ scale*100 }}%</span> 
        <van-slider style="margin-left:10px" v-model="scale" :step="0.25" :max="4" :min="0.5" />
      </div>
      <div style="display:flex;flex:auto;justify-content:space-around;align-items:flex-end">
         <div v-if="!isLoading&&canEdit" @click="showTemplate = true" class="menu-item">
          <van-icon name="invitation" :size="24"  />
          <span>模板</span>
        </div>
        <div v-if="!isLoading&&canEdit" @click="showChangeFile = true" class="menu-item">
          <van-icon name="more-o" :size="24"  />
          <span>文件</span>
        </div>
        <!-- 【骑缝章】添加骑缝章按钮 -->
        <div v-if="!isLoading&&canEdit&&pages>1" @click="showSaddleSeal = true" class="menu-item">
          <van-icon name="bookmark-o" :size="24" />
          <span>骑缝章</span>
        </div>
        <div v-if="notMatch.length" @click="showNotseal = true" class="menu-item">
          <van-icon :badge="notMatch.length" :size="24" name="failure" />
          <span>未签章</span>
        </div>
      </div>
      <!-- <van-button v-if="canEdit" @click="showTemplate = true" type="info" size="small">切换文件</van-button> -->
      <!-- <van-button v-if="canEdit" @click="showTemplate = true" type="info" size="small">使用模板</van-button> -->
      <!-- <van-button v-if="notMatch.length" @click="showNotseal = true" type="danger" size="small">未签章页面</van-button> -->
    </div>
    <!-- <van-action-sheet v-model="showTemplate" :actions="actionList" description="请选择模板" @select="onSelect" /> -->
	<van-action-sheet style="max-height: 50%;" v-model="showNotseal" :actions="notMatch" description="点击跳转页面" @select="goPage"/>
    <div class="box_top"></div>
    <!-- pdf文件展示 -->
    <div v-if="isLoading" style="text-align:center;padding-top:30vh;height:60vh">
      <van-loading  type="spinner" color="#1989fa">加载文件中...</van-loading>
    </div>
    <div v-show="!isLoading" class="pdf-box" v-for="page in pages" :key="page"  @click="move($event, page)" :id="'wrapper_' + page" ref="agreemenContent">
      <canvas class="box" :id="'the-canvas' + page" ref="pdf"></canvas>
      <div  v-for="(item,index) in currentSealList" :key="item.id">
        <!-- 盖章列表 -->
        <seal-item v-if="!isLoading && item.page == page" :item="item" :index="index" @delSelectSeal="()=>delSelectSeal(index)" :key="key1" :x="item.x" :y="item.y" :widthPx="item.widthPx" :heightPx="item.heightPx" @changeSize="(newRect)=>changeSize(newRect,index)" @rotateSeal="()=>rotateSeal(index)">
        </seal-item>
      </div>
      <!-- 【骑缝章】显示骑缝章片段 -->
      <div v-if="saddleSeal && saddleSealFragments.length > 0">
        <div v-for="fragment in saddleSealFragments" :key="fragment.page">
          <div v-if="fragment.page == page" class="saddle-seal-fragment" :style="{
            position: 'absolute',
            left: fragment.x + 'px',
            top: fragment.y + 'px',
            width: fragment.width + 'px',
            height: fragment.height + 'px',
            opacity: 0.8,
            zIndex: 100,
            pointerEvents: 'none'
          }">
            <!-- 【骑缝章-与PC端统一】直接使用dataUrl显示分片图片 -->
            <img v-if="fragment.dataUrl" :src="fragment.dataUrl" :style="{
              width: '100%',
              height: '100%',
              objectFit: 'fill'
            }" />
            <!-- 如果dataUrl还没生成，使用CSS裁切作为fallback -->
            <!-- 【关键-fix】容器宽度使用当前页面片段宽度，不是总宽度 -->
            <div v-else :style="{
              width: fragment.width + 'px',
              height: fragment.height + 'px',
              overflow: 'hidden',
              position: 'relative'
            }">
              <!-- 【关键-fix-方向修正】图片使用总尺寸，通过right偏移显示对应片段 -->
              <!-- 第1页显示最右边，第8页显示最左边 -->
              <img :src="getUrl(saddleSeal.seal_img)" :style="{
                position: 'absolute',
                width: fragment.sealTotalWidth + 'px',
                height: fragment.sealDisplayHeight + 'px',
                right: '-' + fragment.clipLeft + 'px',
                top: '0',
                maxWidth: 'none',
                maxHeight: 'none'
              }" />
            </div>
          </div>
        </div>
      </div>
      
      <!-- <seal-item v-if="!isLoading && item.page == page"
        class="select_seal_img" v-for="(item,index) in currentSealList" :item="item" :index="index" @changeXY="changeXY" @delSelectSeal="()=>delSelectSeal(index)" :key="index"  :left="item.x" :top="item.y" :style="{left:(item.x) +'px',top:(item.y) +'px',width: mmConversionPx(item.width) * getScale(item.page,2)+'px',height:mmConversionPx(item.height) * getScale(item.page,2)+'px'}">
      </seal-item> -->
      <!-- <div  
        :style="{left:(item.x) +'px',top:(item.y) +'px',width: mmConversionPx(item.width) * getScale(item.page)+'px',height:mmConversionPx(item.height) * getScale(item.page)+'px'}"> 
        <img @click.prevent="handel(index)"  :src="getUrl(item.seal_img)" alt="">
        <img v-show="closeIsShowNum == index " @click.prevent="delSelectSeal(index)" class="icon" src="/close.png" alt="">
      </div> -->
    </div>
    <!-- 选中盖章的位置小点 -->
    <div v-if="!isLoading && showPoint" class="pointer" :style="{ top: clientMY + 'px', left: clientX + 'px' }"></div>
    <!-- 印章列表 -->
    <div class="popup_seal"  v-show="mySealIsShow">
      <van-popup
              :overlay="false"
              v-model="mySealIsShow"
              closeable
              position="bottom"
              :style="{ height: '150px',padding:'8px 0',boxSizing: 'border-box',overflow: 'visible',boxShadow:'0px -6px 10px 0px #888888' }">
        <div class="my_seal_label">
          请选择印章
        </div>
        <div class="my_seal_list">
          <div class="seal_box" v-for="i in mySealList" :key="i.id" @click="selectMySeal(i)">
            <img :src="getUrl(i.seal_img)" alt=""/>
          </div>
        </div>
      </van-popup>
    </div>
    <div style="height:44px">
      <van-button v-if="!isLoading && canEdit" type="primary" style="margin: auto;width: 96%;position: fixed;bottom: 0px;left:2%" block  @click="submitList">完成签署</van-button>
    </div>
    <!-- <div class="submit_btn" v-show="selectSealList.length > 0">完成签署</div> -->
	<!-- <div v-if="notMatch.length > 0" class="not-match-wrapper" @click="showNotseal = true">
		<van-icon name="warning-o" />
		<div>未签章</div>
	</div> -->
  <!-- 印章类型 -->
  <van-popup class="popup_seal_type" v-model="showType" closeable :overlay="false" position="bottom" :style="{boxShadow:'0px -6px 10px 0px #888888',padding:'12px 0' }">
      <div class="seal_type">
        <div class="seal_type_item" @click="openType(1)">
          <img src="/seal.png" alt="">
          <span>签章</span>
        </div>
        <div class="seal_type_item" @click="openType(2)">
          <img src="/qianming.png" alt="">
          <span>手写</span>
        </div>
      </div>
  </van-popup>
  <!-- 手写签列表 -->
  <div class="popup_seal"  v-show="tempSealIsShow">
    <van-popup
      :overlay="false"
      v-model="tempSealIsShow"
      closeable
      position="bottom"
      :style="{ padding:'8px 0',boxSizing: 'border-box',overflow: 'visible',boxShadow:'0px -6px 10px 0px #888888' }">
      <div class="my_seal_label">
        请选择临时章
      </div>
      <div class="temp_seal_list">
        <van-button v-if="tempSealList.length<4" icon="plus" type="info" @click="addWrite"></van-button>
        <div class="seal_box" v-for="(item,index) in tempSealList" :key="index" @click="selectMySeal(item)">
           <img :src="item.seal_img" alt=""/>
           <van-icon name="close" @click.stop="delTemp(index)" />
        </div>
        <!-- <div class="seal_box" v-for="i in mySealList" :key="i.id" @click="selectMySeal(i)">
          <img :src="getUrl(i.seal_img)" alt=""/>
        </div> -->
      </div>
    </van-popup>
  </div>
  <van-popup
      v-model="writePop"
      position="center" :style="{width:'90vw',padding:'10px',borderRadius:'6px'}"
      >
      <write ref="writeSeal" @confirm="confirmWrite"></write>
    </van-popup>
  <!-- 模板列表 -->
  <van-popup v-model="showTemplate" position="right" :style="{height:'100vh',width:'50vw'}">
    <div style="padding:20px 0">
      <div style="font-size:18px;font-weight:bold;text-align:center;margin-bottom:20px">请选择模板</div>
      <div style="max-height:74vh;overflow-y: auto;">
        <van-checkbox-group v-model="selectTemplate">
          <van-cell-group>
            <van-cell
              v-for="(item,index) in templateList" :key="index" :title="item.title" :label="item.content" @click="toggle(index)"
            >
              <template #right-icon>
                <van-checkbox :name="item.id" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
      <div style="padding:0 10px;margin-top:20px">
        <van-button type="info" block @click="onSelect">使用模板</van-button>
      </div>
    </div>
  </van-popup>
  <!-- 我的文件 -->
  <van-popup v-model="showChangeFile" position="right" :style="{height:'100vh',width:'60vw'}">
    <div style="padding:20px 0">
      <div style="font-size:18px;font-weight:bold;text-align:center;margin-bottom:20px">请选择文件</div>
      <div>
        <van-cell @click="onSelectFile(item)" v-for="(item,index) in fileList" :key="index" :icon="item.id==file_id?'success':''" :title="item.title" is-link />
      </div>
    </div>
  </van-popup>
  <!-- 【骑缝章】骑缝章选择弹窗 -->
  <van-popup v-model="showSaddleSeal" position="bottom" :style="{ height: '40%', padding: '20px' }">
    <div style="font-size:16px;font-weight:bold;text-align:center;margin-bottom:15px">请选择骑缝章印章</div>
    <div style="display:flex;flex-wrap:wrap;gap:10px;justify-content:center;">
      <div class="seal_box" v-for="seal in mySealList" :key="seal.id" @click="selectSaddleSeal(seal)" style="border:2px solid #eee;padding:5px;border-radius:4px;">
        <img :src="getUrl(seal.seal_img)" alt="" style="width:80px;height:80px;object-fit:contain;"/>
        <div style="text-align:center;font-size:12px;margin-top:5px;">{{ seal.title }}</div>
      </div>
    </div>
    <div style="margin-top:20px;display:flex;justify-content:center;gap:10px;">
      <van-button type="default" @click="showSaddleSeal = false">取消</van-button>
      <van-button type="danger" v-if="saddleSeal" @click="clearSaddleSeal">清除骑缝章</van-button>
    </div>
  </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import * as pdfjs from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker
import SealItem from '@/components/SealItem'
import Write from '@/components/write'

export default {
  name: 'Seal',
  data() {
    return {
      file_id: 0,
      // file_option: [
      //   // { text: '全部商品', value: 0 }
      // ],
      // 我的印章列表
      mySealList:[],
      templateList:[],
      actionList:[],
      mySealIsShow: false,
      // 选择的章数组
      selectSealList:[],
      // currentSealList:[],// 当前页的印章列表
      closeIsShowNum: -1,
      pdfDoc: "",
      pages: 1,
      // fileUrl: '',
      // 记录鼠标的事件
      mouseMoveList: [],
      // 记录第几页
      mouseMovePage: 0,
      clientY: 0,
      clientX: 0,
      clientMY:0,
      sealList: [],
      // 接口数据
      // 文件列表
      electron:{},
      fileList:[],
      scale:1,
      scaleRatio: 1.0, // 缩放比例
      isLoading: true,
      showPoint: false,
      isFlag: false,
      showTemplate: false,
      userInfo:{},
      showNotseal:false,
      showChangeFile:false,
      notMatch: [],// 没有签章的页面
      selectTemplate:[],
      isChange: false,
      showType:false,
      tempSealIsShow: false,
      writePop: false,
      tempSealList:[],
      key1: Math.random(),
      // 【骑缝章】相关数据
      showSaddleSeal: false,
      saddleSeal: null, // 当前选中的骑缝章
      saddleSealFragments: [], // 骑缝章分片数据
      // 【历史骑缝章】历史骑缝章数据
      historySaddleSeals: null // 历史骑缝章分组数据
    }
  },
  components: {
    SealItem,Write
  },
  computed:{
    currentSealList(){
      console.log('重新生成',[...this.selectSealList])
      let obj = this.selectSealList.find(x=>x.fileId == this.file_id)
      if(obj){
        return obj.sealPos
      }
      return []
    },
    canEdit() {
      return this.electron.current_signatory === this.userInfo.id && this.electron.status < 5
    }
  },
  watch:{
    // currentSealList(){
    //   let obj = this.selectSealList.find(item => item.fileId == this.file_id)
    //   if(!obj){
    //     obj = {fileId :this.file_id, sealPos:[]}
    //     this.selectSealList.push(obj)
    //   }
    //   obj.sealPos = [...this.currentSealList]
    //   console.log('this.selectSealList',this.selectSealList)
    // }
    scale(new1, old1) {
      if(!this.isChange){
        this.showPoint = false
        this.tempSealIsShow = false
        this.showTemplate = false
        this.showType = false

        this.scaleRatio = new1 / old1
        // console.log('fff', this.scaleRatio)
        document.querySelectorAll('.box').forEach(item => {
          item.style.width = `${new1 * 100}%`
        })
        this.currentSealList.forEach(item => {
          item.x *= this.scaleRatio
          console.log('y1',item.y,this.scaleRatio)
          item.y *= this.scaleRatio
          console.log('y2',item.y)
          
          item.widthPx *= this.scaleRatio
          item.heightPx *= this.scaleRatio
          // item.widthPx /= this.getScale(item.page)
          // item.heightPx /= this.getScale(item.page)
          // item.pdf_pos_x = this.pxConversionMm(item.x / this.getScale(item.page))
          // item.pdf_pos_y = this.pxConversionMm(item.y / this.getScale(item.page))
        })
        this.key1 = Math.random()
        console.log('this.currentSealList',this.currentSealList)
        
        // 【骑缝章】缩放时重新计算骑缝章位置
        if (this.saddleSeal) {
          console.log('[qz-applet-骑缝章] 缩放比例变化，重新计算位置')
          this.calculateSaddleSealPosition()
        }
      }
        // console.log('a1', [...this.seal_info])
        // document.querySelectorAll('.mark').forEach((item) => {
        //   const child = this.getObjById(item.dataset.domid)
        //   child.pos_x *= this.scaleRatio
        //   child.pos_y *= this.scaleRatio
        //   child.pdf_pos_x = this.pxConversionMm(parseInt(child.pos_x) / this.getScale(child.page))
        //   child.pdf_pos_y = this.pxConversionMm(parseInt(child.pos_y) / this.getScale(child.page))
        //   // this.saveSealPos(item.dataset.domid, (parseInt(item.style.left) * this.scaleRatio), (parseInt(item.style.top) * this.scaleRatio))
        // })
        // console.log('a2', [...this.seal_info])

        // this.$nextTick(() => {
        //   this.resetDom()
        // })
    },
    selectSealList:{
      handler() {
        this.SplicenotMatch()
      },
      deep: true
    }
	
  },
  async created() {
    // 【调试日志-二维码场景】记录URL参数
    console.log('[qz-applet-二维码] URL完整参数:', this.$route.query)
    console.log('[qz-applet-二维码] electronId:', this.$route.query.electronId)
    console.log('[qz-applet-二维码] token:', this.$route.query.token)

    // 【调试日志-二维码场景】检查URL参数有效性
    if (!this.$route.query.electronId) {
      console.error('[qz-applet-二维码-ERROR] electronId为空，无法加载文件')
      this.$toast('参数错误：缺少electronId')
      return
    }
    if (!this.$route.query.token) {
      console.error('[qz-applet-二维码-ERROR] token为空，可能导致接口鉴权失败')
    }

    localStorage.setItem('token', this.$route.query.token)
    this.electronId = this.$route.query.electronId

    // 【调试日志-二维码场景】确认赋值后的electronId
    console.log('[qz-applet-二维码] 赋值后的electronId:', this.electronId)

    await this.getUserInfo()
    this.getSealList();
    this.getFileList();
    this.getMyTemplate()
  },
  mounted() {
    document.addEventListener('UniAppJSBridgeReady', function() {
      uni.getEnv(function(res) {
          console.log('当前环境：' + JSON.stringify(res));
      });
    })
  },
  methods: {
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    //未签署列表跳到指定页面
    goPage(action,index){
      window.scrollTo({top:document.getElementById(`wrapper_${action.index}`).offsetTop - 55, behavior: 'smooth'})
      this.showNotseal = false;	 
    },
    pxConversionMm(value) {
      return value * 25.4 / 72
    },
    mmConversionPx(value) {
      return value * 72 / 25.4
    },
    getScale(page,type) {
      const canvas = document.getElementById('the-canvas' + page)
	    return canvas.clientWidth / canvas.width
    },
    getPageHeight(page) {
      const canvas = document.getElementById('the-canvas' + page)
      return canvas.parentNode.offsetHeight
    },
    getPageWidth(page) {
      const canvas = document.getElementById('the-canvas' + page)
      return canvas.parentNode.offsetWidth
    },
    getTopHeight(page) {
      let height = 0
      for (let i = 1; i <= page; i++) {
        height += this.getPageHeight(i) + 20
      }
      return height
    },
    getSealPos(){
      let obj = this.selectSealList.find(x=>x.fileId == this.file_id)
      if(!obj){
        obj = {fileId :this.file_id, sealPos:[]}
        this.selectSealList.push(obj)
      }
      return obj.sealPos
    },
    getUrl(url){
      const base = process.env.VUE_APP_BASE_API
      return base.endsWith('/') ? base.slice(0, -1) + url : base + url
    },
    // 获取我的印章
    async getSealList(){
      try {
        let res = await this.$request({
          url:'/admin/Seal/getAll',
        });
        if(res.data.code===20000){
          this.mySealList = res.data.data.map(x=>{
            x.type = 1 
            return x
          });
        }else{
          this.$toast(res.data.message)
        }
      } catch (error) {
        console.log('erro1r',error)
      }
      
    },
    async getUserInfo(){
      try {
        let res = await this.$request({
          url:'/admin/Account/info',
        });
        if(res.data.code===20000){
          this.userInfo = res.data.data
        }
      } catch (error) {
        console.log('erro1r',error)
      }
      
    },
    async getMyTemplate() {
       try {
        const that = this;
        let res = await that.$request({
          url:'/admin/Mould/getMyTemplate',
        });
        if(res.data.code===20000){
          that.templateList = res.data.data;
          // that.actionList = that.templateList.map(x=>{
          //   let obj = {
          //     name:x.title
          //   }
          //   if(x.content){
          //     obj.subname = x.content
          //   }
          //   return obj
          // });
        }else{
          this.$toast(res.data.message)
        }
      } catch (error) {
        console.log('erro1r',error)
      }
    },
    onSelect(){
      if(this.selectTemplate.length===0){
        this.$toast('请选择模板')
        return
      }
      this.$dialog.confirm({
        message: '是否确认使用模板？',
      })
      .then(() => {
        let isSeal = false
        this.selectTemplate.forEach(item=>{
          const { seal_coordinate, width } = this.templateList.find(x=>x.id===item)
          const seal_obj = JSON.parse(seal_coordinate)
        
          for (let index = 1; index <= this.pages; index++) {
            const canvas = document.getElementById('the-canvas' + index)
            const pageMM = this.pxConversionMm(parseInt(canvas.width))
            console.log('pageMM', pageMM)
            const error = 50 // 误差范围
            if (pageMM < width + error && pageMM > width - error) { // 如果符合模板尺寸
              isSeal = true
              // seal_obj.forEach(x => {
              //   console.log('xxxxxx',x)
              //   // const seal = this.mySealList.find(y=>y.id == x.sealId)

              //   // this.addPos(seal,this.mmConversionPx(x.pdf_pos_x * this.getScale(index)),this.mmConversionPx(x.pdf_pos_y * this.getScale(index)),index)
              // })
            }else{
              // 如果未签署页面的数组长度为0，添加数组数据
              if (!this.notMatch.some(x => x.index === index)) {
                  this.notMatch.push({ index: index })
              }
            }
          }
        })
        
        // 使用模板后，去除模板盖章的页面
        this.SplicenotMatch()
        if (isSeal) {
          this.$toast('使用模板成功')
        } else {
          this.$toast('模板尺寸不符合，暂无可用模板')
        }
        this.showTemplate = false
      })
    },
    // 去除已经有印章的页面
    SplicenotMatch() {
      let obj = this.selectSealList.find(x=>x.fileId == this.file_id)
          const arr = []
        const that = this
        if(obj){
        this.notMatch.forEach(item => {
              const page = item.index
          if (!obj['sealPos'].some(x => x.page === item.index)) {
              let item = {
                name:'第'+page+'页',
              index:page
              }
            arr.push(item)
          }
          
        }) 
        }else{
          this.notMatch.forEach(item => {
                let items = {
                  name:'第'+item.index+'页',
                index:item.index
                }
              arr.push(items)
          })
        }
        this.notMatch = arr 
    },
    // 获取签署文件
    async getFileList(){
      try {
        // 【调试日志-二维码场景】记录请求参数
        console.log('[qz-applet-二维码] getFileList请求参数:', { id: this.electronId })

        // 【调试日志-二维码场景】检查electronId有效性
        if (!this.electronId) {
          console.error('[qz-applet-二维码-ERROR] electronId为空，无法获取文件列表')
          this.$toast('参数错误：缺少electronId')
          return
        }

        let res = await this.$request({
          url:'/admin/Electron/getElectronDetail',
          data:{
            id: this.electronId
          }
        });

        // 【调试日志-二维码场景】记录接口返回
        console.log('[qz-applet-二维码] getFileList接口返回:', res.data)

        if(res.data.code===20000){
          this.electron = res.data.data;
          this.fileList = this.electron.fileList;

          // 【调试日志-二维码场景】检查文件列表
          if (!this.fileList || this.fileList.length === 0) {
            console.error('[qz-applet-二维码-ERROR] 文件列表为空')
            this.$toast('文件列表为空')
            return
          }

          this.file_id = this.fileList[0].id;

          // 【调试日志-二维码场景】记录文件信息
          console.log('[qz-applet-二维码] 文件信息:', {
            electronId: this.electron.id,
            title: this.electron.title,
            fileList: this.fileList,
            firstFileId: this.file_id,
            firstFilePath: this.fileList[0].file
          })

          // 【历史骑缝章-回显】处理历史印章记录
          this.processHistorySeals()

          // this.file_option = this.fileList.map(x=>{
          //   return {
          //     text: x.title,
          //     value: x.id,
          //   }
          // })
          this.changeFile()
        }else{
          console.error('[qz-applet-二维码-ERROR] 接口返回错误:', res.data.message)
          this.$toast(res.data.message)
        }
      } catch (error) {
        console.error('[qz-applet-二维码-ERROR] getFileList错误:', error)
        this.$toast('获取文件列表失败')
      }

    },
    // changeXY(index){
    //   let obj = this.currentSealList[index]
    //   // console.log('obj',obj)
    //   obj.pdf_pos_x = this.pxConversionMm(obj.x / this.getScale(obj.page))
    //   obj.pdf_pos_y = this.pxConversionMm(obj.y / this.getScale(obj.page))
    // },
    onSelectFile(item){
      if(this.file_id!==item.id){
        this.isChange = true
        this.scaleRatio = 1 / this.scale
        this.scale = 1
        // console.log('ratio',this.scaleRatio,[...this.currentSealList])
        this.currentSealList.forEach(item => {
          item.x *= this.scaleRatio
          item.y *= this.scaleRatio
          // item.pdf_pos_x = this.pxConversionMm(item.x / this.getScale(item.page))
          // item.pdf_pos_y = this.pxConversionMm(item.y / this.getScale(item.page))
        })
        this.showChangeFile = false
        this.showPoint = false
        setTimeout(async ()=>{
          this.file_id = item.id
          await this.changeFile()
          this.isChange = false
        },500)
        // this.isChange = false
      }
    },
    async changeFile(){
      // 【调试日志-二维码场景】切换文件
      console.log('[qz-applet-二维码] changeFile开始，file_id:', this.file_id)

      // 【调试日志-二维码场景】检查文件列表和文件ID
      if (!this.fileList || this.fileList.length === 0) {
        console.error('[qz-applet-二维码-ERROR] fileList为空')
        this.$toast('文件列表为空')
        return
      }

      const currentFile = this.fileList.find(x=>x.id==this.file_id)
      if (!currentFile) {
        console.error('[qz-applet-二维码-ERROR] 找不到对应文件，file_id:', this.file_id, '可用文件:', this.fileList.map(f => ({id: f.id, title: f.title})))
        this.$toast('找不到对应文件')
        return
      }

      if (!currentFile.file) {
        console.error('[qz-applet-二维码-ERROR] 文件路径为空，文件信息:', currentFile)
        this.$toast('文件路径为空')
        return
      }

      const fileUrl = this.getUrl(currentFile.file)
      console.log('[qz-applet-二维码] 加载文件URL:', fileUrl)

      await this._loadFile(fileUrl);
      this.notMatch = []
    },
    // 【历史骑缝章-回显】处理历史印章记录
    // 【关键-回显规则】从 saddle_config 读取 render_mode 判断是否回显
    //   - render_mode = 'image' → 需要回显（图片写入PDF）
    //   - render_mode = 'annotation' → 不需要回显（PDF自身带印章）
    processHistorySeals() {
      console.log('[qz-applet-历史印章-回显规则] 开始处理历史印章记录')
      
      if (!this.fileList || this.fileList.length === 0) {
        console.log('[qz-applet-历史印章] 文件列表为空，跳过')
        return
      }
      
      // 遍历所有文件，查找历史印章
      this.fileList.forEach(file => {
        if (file.seal_history && file.seal_history.length > 0) {
          console.log(`[qz-applet-历史印章-回显规则] 文件${file.id}有${file.seal_history.length}个历史印章`)
          
          // 【关键-回显规则】先按骑缝章分组，从第一个片段读取 render_mode
          const sealGroups = {}
          file.seal_history.forEach(seal => {
            const timeKey = seal.sign_time ? seal.sign_time.substring(0, 16) : 'unknown'
            const key = `${seal.user_id || 'unknown'}_${seal.seal_id}_${timeKey}`
            
            if (!sealGroups[key]) {
              sealGroups[key] = {
                saddle_config: seal.saddle_config, // 第一个片段的saddle_config
                fragments: []
              }
            }
            sealGroups[key].fragments.push(seal)
          })

          // 【关键-回显规则】过滤需要回显的组
          // 【修正】image模式=图片写入=不需要回显, annotation模式=PDF自带=需要回显
          const groupsToRender = []
          for (const [key, group] of Object.entries(sealGroups)) {
            let renderMode = 'annotation' // 默认需要回显（兼容旧数据）

            if (group.saddle_config) {
              try {
                const config = typeof group.saddle_config === 'string'
                  ? JSON.parse(group.saddle_config)
                  : group.saddle_config
                renderMode = config.render_mode || 'annotation'
              } catch (e) {
                console.warn('[qz-applet-历史印章-回显规则] 解析saddle_config失败:', e)
              }
            }

            if (renderMode === 'annotation') {
              groupsToRender.push(group)
              console.log(`[qz-applet-历史印章-回显规则] 组${key}: render_mode=${renderMode}, 需要回显`)
            } else {
              console.log(`[qz-applet-历史印章-回显规则] 组${key}: render_mode=${renderMode}, 跳过`)
            }
          }

          // 展开需要回显的片段
          const sealsToRender = []
          groupsToRender.forEach(group => {
            sealsToRender.push(...group.fragments)
          })
          
          console.log(`[qz-applet-历史印章-回显规则] 原始印章数:${file.seal_history.length}, 需要回显数:${sealsToRender.length}`)
          
          if (sealsToRender.length === 0) {
            console.log('[qz-applet-历史印章-回显规则] 所有印章都是annotation模式，无需回显')
            return
          }
          
          // 筛选出骑缝章（type=2）
          const saddleSeals = sealsToRender.filter(seal => seal.type == 2)
          console.log(`[qz-applet-历史印章] 骑缝章数量: ${saddleSeals.length}`)
          
          if (saddleSeals.length > 0) {
            // 按签署时间分组，每个签署记录一个骑缝章
            // 【关键-fix】使用 renderGroups 避免与前面的 sealGroups 重复定义
            const renderGroups = {}
            saddleSeals.forEach(seal => {
              const timeKey = seal.sign_time ? seal.sign_time.substring(0, 16) : 'unknown'
              const key = `${seal.user_id || 'unknown'}_${seal.seal_id}_${timeKey}`
              
              if (!renderGroups[key]) {
                renderGroups[key] = {
                  seal_id: seal.seal_id,
                  seal_title: seal.seal_title,
                  seal_img: seal.seal_img,
                  user_name: seal.user_name,
                  fragments: []
                }
              }
              renderGroups[key].fragments.push({
                page: seal.page_number,
                pos_x: seal.pos_x,
                pos_y: seal.pos_y,
                width: seal.width,
                height: seal.height
              })
            })
            
            console.log('[qz-applet-历史印章] 骑缝章分组:', Object.keys(renderGroups))
            
            // 保存历史骑缝章数据，在PDF加载完成后渲染
            this.historySaddleSeals = renderGroups
          }
        }
      })
    },
    
    // 【历史骑缝章-渲染】渲染历史骑缝章到PDF
    async renderHistorySaddleSeals() {
      console.log('[qz-applet-历史骑缝章] 开始渲染历史骑缝章')
      
      if (!this.historySaddleSeals) {
        console.log('[qz-applet-历史骑缝章] 没有历史骑缝章数据')
        return
      }
      
      for (const [key, sealData] of Object.entries(this.historySaddleSeals)) {
        console.log(`[qz-applet-历史骑缝章] 渲染骑缝章 ${key}，片段数: ${sealData.fragments.length}`)
        
        // 【关键-按页面排序】确保按page顺序渲染，第1页index=0，第8页index=7
        const sortedFragments = sealData.fragments.sort((a, b) => a.page - b.page)
        
        // 【关键-使用for...of支持异步渲染】
        for (let idx = 0; idx < sortedFragments.length; idx++) {
          await this.renderHistorySaddleSealFragment(sortedFragments[idx], sealData, idx)
        }
      }
    },
    
    // 【历史骑缝章-渲染单个片段】
    async renderHistorySaddleSealFragment(fragment, sealData, index) {
      const { page, pos_x, pos_y, width, height } = fragment
      
      // 【关键-坐标转换】将毫米坐标转换为屏幕像素坐标
      // 公式：屏幕像素 = 毫米 * 72 / 25.4 * 页面缩放比例
      const pageScale = this.getScale(page)
      const mmToPxFactor = 72 / 25.4  // ≈ 2.8346
      
      const posX = pos_x * mmToPxFactor * pageScale
      const posY = pos_y * mmToPxFactor * pageScale
      
      // 【关键-fix】数据库保存的是原始印章尺寸，需要计算分片尺寸
      // 分片宽度 = 原始宽度 / 页数，分片高度 = 原始高度
      const fragmentCount = sealData.fragments.length
      const originalWidth = width || 40
      const originalHeight = height || 40
      const fragmentWidth = originalWidth / fragmentCount
      const fragmentHeight = originalHeight
      
      const sealWidth = fragmentWidth * mmToPxFactor * pageScale
      const sealHeight = fragmentHeight * mmToPxFactor * pageScale
      
      console.log(`[qz-applet-历史骑缝章] 渲染片段 ${index + 1}，页面: ${page}`, {
        原始毫米坐标: { x: pos_x, y: pos_y, width: originalWidth, height: originalHeight },
        分片尺寸: { width: fragmentWidth, height: fragmentHeight },
        转换系数: { mmToPx: mmToPxFactor, pageScale: pageScale },
        计算过程: {
          posX: `${pos_x}mm * ${mmToPxFactor} * ${pageScale.toFixed(4)} = ${posX.toFixed(2)}px`,
          posY: `${pos_y}mm * ${mmToPxFactor} * ${pageScale.toFixed(4)} = ${posY.toFixed(2)}px`
        },
        最终像素坐标: { x: posX.toFixed(2), y: posY.toFixed(2), width: sealWidth.toFixed(2), height: sealHeight.toFixed(2) }
      })
      
      // 【关键-生成印章分片】从右往左切，与Java后端保持一致
      const fragmentIndex = index // 第1页index=0，第8页index=7
      const fragmentImage = await this.generateSaddleSealFragment(
        sealData.seal_img, 
        fragmentCount, 
        fragmentIndex
      )
      
      // 创建印章DOM元素
      const dom = document.createElement('div')
      dom.className = 'history-saddle-seal'
      dom.style.position = 'absolute'
      dom.style.left = posX + 'px'
      dom.style.top = posY + 'px'
      dom.style.width = sealWidth + 'px'
      dom.style.height = sealHeight + 'px'
      dom.style.zIndex = '9999'
      dom.style.boxSizing = 'border-box'
      
      // 使用分片图片
      if (fragmentImage) {
        dom.style.backgroundImage = `url(${fragmentImage})`
        dom.style.backgroundSize = '100% 100%'
        dom.style.backgroundRepeat = 'no-repeat'
        dom.style.backgroundPosition = 'center'
      } else {
        // fallback：显示占位符
        dom.style.border = '2px dashed orange'
        dom.style.backgroundColor = 'rgba(255, 165, 0, 0.1)'
        dom.innerHTML = `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:10px;color:orange;writing-mode:vertical-rl;">骑缝章</div>`
      }
      
      // 添加到对应页面容器
      const pageContainer = document.getElementById('the-canvas' + page)
      if (pageContainer && pageContainer.parentNode) {
        pageContainer.parentNode.appendChild(dom)
        console.log(`[qz-applet-历史骑缝章] 片段已添加到页面 ${page}`)
      } else {
        console.warn(`[qz-applet-历史骑缝章] 页面容器不存在: the-canvas${page}`)
      }
    },
    
    // 【历史骑缝章-生成单个分片】从右往左切，与Java后端保持一致
    generateSaddleSealFragment(sealImg, pageCount, fragmentIndex) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        
        img.onload = () => {
          const { width, height } = img
          const singleWidth = width / pageCount
          
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          canvas.width = singleWidth
          canvas.height = height
          
          // 【关键-方向统一】从右往左切：第i页从右边第i个位置开始切
          // 第1页(fragmentIndex=0)显示最右边，第8页显示最左边
          const sourceX = (pageCount - 1 - fragmentIndex) * singleWidth
          ctx.drawImage(img, sourceX, 0, singleWidth, height, 0, 0, singleWidth, height)
          
          console.log(`[qz-applet-历史骑缝章] 生成分片 ${fragmentIndex + 1}/${pageCount}，从x=${sourceX}切割`)
          resolve(canvas.toDataURL('image/png'))
        }
        
        img.onerror = (err) => {
          console.error('[qz-applet-历史骑缝章] 印章图片加载失败:', err)
          resolve(null) // 返回null，使用fallback
        }
        
        img.src = this.getUrl(sealImg)
      })
    },
    
    // 【骑缝章】选择骑缝章印章
    selectSaddleSeal(seal) {
      console.log('[qz-applet-骑缝章] 选择骑缝章:', seal)
      this.saddleSeal = seal
      this.showSaddleSeal = false
      // 计算骑缝章位置（Java后端会处理图片下载和切割）
      this.calculateSaddleSealPosition()
      this.$toast.success('骑缝章已添加')
    },
    // 【骑缝章】清除骑缝章
    clearSaddleSeal() {
      console.log('[qz-applet-骑缝章] 清除骑缝章')
      this.saddleSeal = null
      this.saddleSealFragments = []
      this.showSaddleSeal = false
      this.$toast.success('骑缝章已清除')
    },
    // 【骑缝章】计算骑缝章位置（默认右侧，每页一个片段）
    calculateSaddleSealPosition() {
      if (!this.saddleSeal || this.pages < 2) {
        console.log('[qz-applet-骑缝章] 无法计算骑缝章位置')
        return
      }

      console.log('[qz-applet-骑缝章] 开始计算骑缝章位置，页数:', this.pages)

      // 【骑缝章-页数提示】当页数过多时提示用户
      const MAX_RECOMMENDED_PAGES = 20  // 建议最大页数
      if (this.pages > MAX_RECOMMENDED_PAGES) {
        const fragmentWidthMm = (this.saddleSeal.width_mm || 40) / this.pages
        this.$toast({
          message: `当前文档${this.pages}页，骑缝章每页仅显示${fragmentWidthMm.toFixed(1)}mm，可能难以识别。建议拆分成多个文档签署。`,
          duration: 1000,
          position: 'middle'
        })
        console.warn(`[qz-applet-骑缝章-页数提示] 页数过多(${this.pages}页)，每页片段宽度仅${fragmentWidthMm.toFixed(1)}mm`)
      }

      const fragments = []

      // 获取第一页的尺寸作为参考
      const firstCanvas = document.getElementById('the-canvas1')
      if (!firstCanvas) return

      const displayWidth = firstCanvas.clientWidth
      const displayHeight = firstCanvas.clientHeight
      const internalWidth = firstCanvas.width
      const internalHeight = firstCanvas.height

      // 计算缩放比例
      const scaleX = displayWidth / internalWidth
      const scaleY = displayHeight / internalHeight

      // 【骑缝章-尺寸统一-方案C】固定印章整体尺寸，与普通印章相同
      // 默认40mm×40mm，与个人签名40mm×16mm保持一致
      const sealWidthMm = this.saddleSeal.width_mm || 40
      const sealHeightMm = this.saddleSeal.height_mm || 40
      
      // 【骑缝章-尺寸统一】将毫米转换为像素（72 DPI: 1mm = 72/25.4 px）
      const mmToPxFactor = 72 / 25.4
      
      // 【方案C】印章整体尺寸固定为数据库中的尺寸（与普通印章相同）
      const sealTotalWidthMm = sealWidthMm  // 印章总宽度 = 原始印章宽度
      const sealTotalHeightMm = sealHeightMm  // 印章总高度 = 原始印章高度
      
      // 【方案C】考虑页面缩放比例，计算屏幕像素尺寸
      const sealTotalWidth = sealTotalWidthMm * mmToPxFactor * scaleX
      const sealDisplayHeight = sealTotalHeightMm * mmToPxFactor * scaleY
      // 【方案C】每页片段宽度 = 总宽度 / 页数
      const fragmentWidth = sealTotalWidth / this.pages

      console.log('[qz-applet-骑缝章-尺寸统一-方案C] 印章尺寸计算:', {
        sealWidthMm,
        sealHeightMm,
        sealTotalWidthMm,
        sealTotalHeightMm,
        mmToPxFactor,
        scaleX,
        scaleY,
        sealTotalWidth,
        sealDisplayHeight,
        fragmentWidth,
        pages: this.pages
      })

      for (let page = 1; page <= this.pages; page++) {
        // 获取当前页面canvas
        const canvas = document.getElementById('the-canvas' + page)
        if (!canvas) continue

        const pageDisplayWidth = canvas.clientWidth
        const pageDisplayHeight = canvas.clientHeight
        const pageInternalWidth = canvas.width
        const pageInternalHeight = canvas.height

        const pageScaleX = pageDisplayWidth / pageInternalWidth
        const pageScaleY = pageDisplayHeight / pageInternalHeight

        // 【骑缝章-尺寸统一-方案C】计算位置：页面右侧贴边，垂直居中
        // 【方案C】印章整体尺寸固定，每页显示片段宽度 = 总宽度 / 页数
        const pageSealTotalWidth = sealTotalWidthMm * mmToPxFactor * pageScaleX
        const pageSealDisplayHeight = sealTotalHeightMm * mmToPxFactor * pageScaleY
        const pageFragmentWidth = pageSealTotalWidth / this.pages
        
        // x坐标：右侧贴边，无间隙（屏幕像素坐标）
        const x = pageDisplayWidth - pageFragmentWidth
        // y坐标：垂直居中（屏幕像素坐标）
        const y = (pageDisplayHeight - pageSealDisplayHeight) / 2

        // 【关键-坐标转换】转换为内部坐标（PDF坐标系）
        // 公式：内部坐标 = 屏幕像素坐标 / 缩放比例
        const internalX = x / pageScaleX
        const internalY = y / pageScaleY
        const internalFragmentWidth = pageFragmentWidth / pageScaleX
        const internalSealHeight = pageSealDisplayHeight / pageScaleY

        // 转换为毫米坐标（用于后端）
        const pdf_pos_x = this.pxConversionMm(internalX)
        const pdf_pos_y = this.pxConversionMm(internalY)
        const width_mm = this.pxConversionMm(internalFragmentWidth)
        const height_mm = this.pxConversionMm(internalSealHeight)
        
        // 【调试日志-坐标计算】详细记录坐标转换过程
        console.log(`[qz-applet-骑缝章-尺寸统一] 页面${page}坐标计算详情:`, {
          画布尺寸: { 
            显示: { width: pageDisplayWidth, height: pageDisplayHeight }, 
            内部: { width: pageInternalWidth, height: pageInternalHeight } 
          },
          缩放比例: { x: pageScaleX.toFixed(4), y: pageScaleY.toFixed(4) },
          屏幕像素坐标: { x, y, fragmentWidth: pageFragmentWidth, sealDisplayHeight: pageSealDisplayHeight },
          内部坐标: { 
            x: internalX.toFixed(2), 
            y: internalY.toFixed(2), 
            width: internalFragmentWidth.toFixed(2), 
            height: internalSealHeight.toFixed(2) 
          },
          毫米坐标: { 
            x: pdf_pos_x.toFixed(2), 
            y: pdf_pos_y.toFixed(2), 
            width: width_mm.toFixed(2), 
            height: height_mm.toFixed(2) 
          }
        })

        // 【骑缝章裁切】计算clip位置：横向裁切，每页显示不同部分
        // 【关键-使用第一页的fragmentWidth计算clipLeft，确保CSS裁切正确】
        // 第1页显示最右边，最后一页显示最左边
        const clipLeft = (this.pages - page) * fragmentWidth

        fragments.push({
          page: page,
          x: x,
          y: y,
          width: pageFragmentWidth,
          height: pageSealDisplayHeight,
          pdf_pos_x: pdf_pos_x,
          pdf_pos_y: pdf_pos_y,
          width_mm: width_mm,
          height_mm: height_mm,
          // 【骑缝章裁切】裁切参数 - 使用第一页计算的统一尺寸
          clipLeft: clipLeft,
          sealTotalWidth: sealTotalWidth,
          sealDisplayHeight: sealDisplayHeight,
          // 【新增】记录第一页的fragmentWidth，用于CSS裁切计算
          baseFragmentWidth: fragmentWidth
        })

        console.log(`[qz-applet-骑缝章] 页面${page}位置:`, { x, y, width: pageFragmentWidth, height: pageSealDisplayHeight, clipLeft })
      }

      this.saddleSealFragments = fragments
      console.log('[qz-applet-骑缝章] 骑缝章分片计算完成:', fragments)
    },
    // 【骑缝章】获取骑缝章提交数据
    getSaddleSealData() {
      if (!this.saddleSeal || this.saddleSealFragments.length === 0) {
        console.log('[qz-applet-骑缝章] 没有骑缝章数据，返回null')
        return null
      }

      // 【关键-与PC端统一-方案C】计算印章总尺寸
      // 【方案C】印章整体尺寸固定为数据库中的尺寸（与普通印章相同）
      const totalWidthMm = this.saddleSeal.width_mm || 40
      const totalHeightMm = this.saddleSeal.height_mm || 40

      console.log('[qz-applet-骑缝章-方案C] 印章总尺寸(毫米):', { totalWidthMm, totalHeightMm, pages: this.pages })
      console.log('[qz-applet-骑缝章] 印章图片URL:', this.saddleSeal.seal_img)

      // 【关键】获取第一页的缩放比例，用于日志记录
      const firstCanvas = document.getElementById('the-canvas1')
      const scaleX = firstCanvas ? firstCanvas.clientWidth / firstCanvas.width : 1
      console.log('[qz-applet-骑缝章] 页面缩放比例:', { scaleX, clientWidth: firstCanvas?.clientWidth, width: firstCanvas?.width })

      // 【关键-fix】提交屏幕像素坐标，PHP端会根据source=applet进行正确的坐标转换
      const fragments = this.saddleSealFragments.map(f => {
        console.log(`[qz-applet-骑缝章] 页面${f.page}坐标:`, {
          屏幕坐标: { x: f.x, y: f.y, width: f.width, height: f.height },
          缩放比例: this.getScale(f.page),
          内部坐标: { x: f.x / this.getScale(f.page), y: f.y / this.getScale(f.page) },
          毫米坐标: { x: this.pxConversionMm(f.x / this.getScale(f.page)), y: this.pxConversionMm(f.y / this.getScale(f.page)) }
        })
        
        return {
          page: f.page,
          x: f.x,  // 【关键】提交屏幕像素坐标
          y: f.y,
          width: f.width,
          height: f.height,
          scale: this.getScale(f.page)  // 【关键】提交缩放比例，PHP端用于转换
        }
      })

      return {
        sealId: this.saddleSeal.id,
        seal_img: this.saddleSeal.seal_img,
        // 【关键-与PC端统一-方案C】添加原始印章尺寸（毫米），用于后端保存和PC端回显
        // 【方案C】印章整体尺寸固定为数据库中的尺寸（与普通印章相同）
        original_width_mm: totalWidthMm,
        original_height_mm: totalHeightMm,
        // 【关键-来源标识】标记为小程序请求，PHP端会进行屏幕像素->内部坐标->毫米的转换
        source: 'applet',
        fragments: fragments
      }
    },

    // 完成签署
    async submitList(){
      if(this.isFlag){
        return
      }

      // 【骑缝章】检查是否有骑缝章
      const hasSaddleSeal = this.saddleSeal && this.saddleSealFragments.length > 0

      if(this.selectSealList.length!=this.fileList.length && !hasSaddleSeal){
        this.$toast('还有文件未签署');
        return
      }

      
      
      try{
        // this.selectSealList.forEach(x=>{
        //   x.sealPos.forEach(obj=>{
        //     obj.pdf_pos_x = this.pxConversionMm(obj.x / this.getScale(obj.page))
        //     obj.pdf_pos_y = this.pxConversionMm(obj.y / this.getScale(obj.page))
        //   })
        // })
        console.log('ddddd',this.selectSealList)
        // return
        this.isFlag = true;
        this.$toast.loading({
          message: '签署中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0
        });

        // 【骑缝章】构建提交数据
        const submitData = {
          electron_id: this.electronId,
          seal_info: this.selectSealList
        }

        // 【骑缝章】如果有骑缝章，添加到提交数据（dataUrl已预生成）
        const saddleSealData = this.getSaddleSealData()
        if (saddleSealData) {
          submitData.saddle_seal_info = [saddleSealData]
          console.log('[qz-applet-骑缝章] 提交数据包含骑缝章:', saddleSealData)
          
          // 【骑缝章-页数提示】提交前再次提示页数过多
          const MAX_RECOMMENDED_PAGES = 20
          if (this.pages > MAX_RECOMMENDED_PAGES) {
            const fragmentWidthMm = (this.saddleSeal.width_mm || 40) / this.pages
            console.warn(`[qz-applet-骑缝章-提交提示] 当前文档${this.pages}页，骑缝章每页仅显示${fragmentWidthMm.toFixed(1)}mm，可能难以识别`)
          }
        }
        
        console.log('[qz-applet] 完整提交数据:', submitData)

        let res = await this.$request({
          url:'/admin/Electron/confirmElectron',
          data: submitData
        });
        if(res.data.code===20000){
          this.$toast.success('签署成功');
          setTimeout(()=>{
            // 【H5兼容】使用window.location.href代替uni.switchTab
            if (typeof uni !== 'undefined' && uni.switchTab) {
              // 小程序环境
              uni.switchTab({
                url: '/pages/index/index'
              });
            } else {
              // H5环境
              window.location.href = '/#/pages/index/index';
            }
          },1000)
        }else{
          this.$toast.fail(res.data.message);
        }
        //跳转回小程序
        
      }catch(e){
        this.$toast.fail('签署失败');
      }finally{
        this.isFlag = false;
      }
    },
    addPos(seal_info,x,y,page){
      let obj = {
        // width: seal_info.width_mm,
        // height: seal_info.height_mm,
        widthPx: this.mmConversionPx(seal_info.width_mm * this.getScale(page)),
        heightPx: this.mmConversionPx(seal_info.height_mm * this.getScale(page)),
        seal_img: seal_info.seal_img,
        sealId: seal_info.id,
        x: x,
        y: y,
        type:seal_info.type,
        pdf_pos_x: this.pxConversionMm(x / this.getScale(page)),
        pdf_pos_y: this.pxConversionMm(y / this.getScale(page)),
        page: page,
        sealInfo: seal_info.type==1?{}:seal_info,
        id: this.guid()
      }
      console.log('obj1111',obj)
      this.getSealPos().push(obj);
    },
    changeSize(newRect,index){
      // console.log('ddddd')
      if(newRect.width>0 && newRect.height>0){
        const item = this.currentSealList[index]
        item.widthPx = newRect.width
        item.heightPx = newRect.height
        item.x = newRect.left
        item.y = newRect.top
        item.pdf_pos_x = this.pxConversionMm(item.x / this.getScale(item.page))
        item.pdf_pos_y = this.pxConversionMm(item.y / this.getScale(item.page))
        if(item.type==2){
          item.sealInfo.width_mm = this.pxConversionMm(item.widthPx / this.getScale(item.page))
          item.sealInfo.height_mm = this.pxConversionMm(item.heightPx / this.getScale(item.page)) 
        }
        console.log('item',item)
      }
    },
    // 选择印章-盖章
    selectMySeal(item){
      // const x = this.clientX - this.mmConversionPx(item.width_mm)  * this.getScale(this.mouseMovePage)/2 + 5
      // const y = this.clientY - this.mmConversionPx(item.height_mm) * this.getScale(this.mouseMovePage)/2 + 5
      const x = this.clientX
      const y = this.clientY
      // let obj = {
      //   width: width,
      //   seal_img: item.seal_img,
      //   sealId: item.id,
      //   x: x,
      //   y: y,
      //   pdf_pos_x: this.pxConversionMm(x / this.getScale(this.mouseMovePage)),
      //   pdf_pos_y: this.pxConversionMm(y / this.getScale(this.mouseMovePage)),
      //   page: this.mouseMovePage,
      // }
      // 将选择的印章存到数组中
      // this.getSealPos().push(obj);
      this.addPos(item,x,y,this.mouseMovePage);
      this.mySealIsShow = false;
      this.showPoint = false
    },
    handel(index){
      this.closeIsShowNum = index;
    },
    delSelectSeal(index){
      // console.log('aa',this.getSealPos())
      // console.log('bb',index)
      this.getSealPos().splice(index,1)
      // this.selectSealList = [...this.selectSealList]
      this.closeIsShowNum = -1
    },
    rotateSeal(index){
      const item = this.currentSealList[index]
      if(item.sealInfo.seal_img){
        item.sealInfo.seal_img = item.seal_img
      }
      console.log('旋转',item)
      // rotateBase64Img(item.seal_img,90,res=>{
      //   console.log('res',res)
      //   item.seal_img = res
      // })
    },
    // 鼠标移动事件
    move(e, page) {
      if(!this.canEdit){
        return
      }
      if(e.target.classList.length == 0 ||e.target.classList[0] == 'icon'){
        return
      }
      // this.mySealIsShow = true;
      if(!this.mySealIsShow && !this.tempSealIsShow){
         this.showType = true;
      }
      // that.mouseMoveList = e.changedTouches[0];
      this.mouseMovePage = page;
      // 获取当前的点击的第几页
      let wrapper = document.getElementById('wrapper_' + this.mouseMovePage);
      // 获取当前页元素距顶部的距离
      let boxTop = wrapper.getBoundingClientRect().top;
      let boxHeight = wrapper.getBoundingClientRect().height;
      // 【关键-与PC端统一】计算相对于canvas的坐标
      // getBoundingClientRect 返回的是视口坐标，不需要再加滚动偏移
      const canvas = document.getElementById('the-canvas' + page);
      const canvasRect = canvas.getBoundingClientRect();
      // 计算相对于canvas的坐标
      this.clientX = e.clientX - canvasRect.left;
      this.clientY = e.clientY - canvasRect.top;
      // 兼容旧逻辑
      this.clientMY = e.clientY - 5 - boxTop + 53;
      if (this.mouseMovePage > 1) {
        let Yheight =  this.totalheight(this.mouseMovePage);
            //that.clientMY = e.clientY + ((that.mouseMovePage - 1) * boxHeight) - boxTop + 53;
        this.clientMY = e.clientY + Yheight - boxTop + 53;
      }
      this.showPoint = true
    },
    //计算之前页面的总高度
    totalheight(page){
      console.log(page);
      let height = 0;
      for(let i=1;i<page;i++){
        height +=  document.getElementById('wrapper_' + i).getBoundingClientRect().height;
      }
      return height;
    },
    // 渲染pdf文件
    async _renderPage(num) {
      console.log(`[qz-applet] 开始渲染第${num}页`)
      try {
        const page = await this.pdfDoc.getPage(num)
        console.log(`[qz-applet] 获取第${num}页成功`)
        let canvas = document.getElementById('the-canvas' + num)
        if (!canvas) {
          console.error(`[qz-applet-ERROR] 找不到canvas元素: the-canvas${num}`)
          return
        }
        console.log(`[qz-applet] 找到canvas元素`)
        let ctx = canvas.getContext('2d')
        // let dpr = window.devicePixelRatio || 1
        // let bsr = ctx.webkitBackingStorePixelRatio ||
        //   ctx.mozBackingStorePixelRatio ||
        //   ctx.msBackingStorePixelRatio ||
        //   ctx.oBackingStorePixelRatio ||
        //   ctx.backingStorePixelRatio || 1
        // let ratio = dpr / bsr
        let viewport = page.getViewport({ scale: 1 })
        console.log(`[qz-applet] 视口尺寸:`, viewport.width, 'x', viewport.height)
        canvas.width = viewport.width
        canvas.height = viewport.height
        // canvas.style.width = viewport.width + 'px'
        canvas.style.width = 100 + '%'  //设置宽度
        // canvas.style.height = 700 + 'px'  //设置高度，可以不设
        // ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
        let renderContext = {
          canvasContext: ctx,
          viewport: viewport
        }
        console.log(`[qz-applet] 开始渲染第${num}页到canvas`)
        await page.render(renderContext).promise
        console.log(`[qz-applet] 第${num}页渲染完成`)
        if (this.pages > num) {
          await this._renderPage(num + 1)
        }
      } catch (error) {
        console.error(`[qz-applet-ERROR] PDF第${num}页渲染失败:`, error)
      }
    },
    // 加载pdf文件
    async _loadFile(url) {
      console.log('[qz-applet-二维码] 开始加载PDF:', url)

      // 【调试日志-二维码场景】检查URL有效性
      if (!url || url === 'undefined' || url === 'null') {
        console.error('[qz-applet-二维码-ERROR] PDF URL无效:', url)
        this.$toast('文件URL无效')
        this.isLoading = false
        return
      }

      this.isLoading = true
      try {
        console.log('[qz-applet-二维码] 调用pdfjs.getDocument，URL:', url)
        const pdf = await pdfjs.getDocument(url).promise
        console.log('[qz-applet-二维码] PDF加载成功，页数:', pdf.numPages)
        this.pdfDoc = pdf
        this.pages = this.pdfDoc.numPages
        this.$nextTick(async () => {
          console.log('[qz-applet-二维码] 开始渲染PDF页面，总页数:', this.pages)
          await this._renderPage(1)
          // this.currentSealList = []
          // 渲染签章
          // console.log('aaa',this.file_id)
          // const obj = this.selectSealList.find(x=>x.fileId==this.file_id)
          // if(obj){
          //   this.currentSealList = [... obj.sealPos ]
          // }
          
          // 【历史骑缝章-渲染】PDF渲染完成后，仅在可编辑模式下渲染历史骑缝章
          // 已完成的文件(status >= 5)PDF本身已包含骑缝章，无需前端渲染
          if (this.canEdit) {
            setTimeout(() => {
              this.renderHistorySaddleSeals()
              this.$forceUpdate()
            }, 1000)
          } else {
            console.log('[qz-applet-历史骑缝章] 文件已完成，跳过前端渲染，使用PDF自带印章')
          }
          this.showPoint = false
          this.isLoading = false
          console.log('[qz-applet-二维码] PDF加载完成')
        })
      } catch (error) {
        console.error('[qz-applet-二维码-ERROR] PDF加载失败:', error)
        console.error('[qz-applet-二维码-ERROR] 失败的URL:', url)
        this.$toast('PDF加载失败: ' + (error.message || '未知错误'))
        this.isLoading = false
      }
    },
    openType(type){
      // this.showType = false
      if(type===1){
        this.mySealIsShow = true
      }else{
        if(this.tempSealList.length==0){
          this.writePop = true
        }
        this.tempSealIsShow = true
      }
    },
    addWrite(){
      this.writePop = true
      this.$nextTick(()=>{
        this.$refs.writeSeal.reset()
      })
    },
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0
        var v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    async confirmWrite(obj){
      const {url,width,height} = obj
      const data = {
        id:this.guid(),
        seal_img: url,
        width_mm: this.pxConversionMm(width),
        height_mm: this.pxConversionMm(height),
        type:2
      }
      this.tempSealList.push(data)
      if(obj.type=='confirm'){
        this.selectMySeal(data)
      }
      this.writePop = false
    },
    delTemp(index){
      this.tempSealList.splice(index,1)
    }
  }
}
</script>
<style lang="scss" scoped>

::v-deep .van-dropdown-menu__bar{
        box-shadow: none;
}
.home{
  background: #f5f5f5;
  .top_menus{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    // padding-top: 3px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    background-color: #fff;
    // align-items: center;
    height: 50px;
    /*顶部提示信息*/
    .label_tips{
      font-size: 15px;
      line-height: 20px;
      text-align: center;
      color: #ee0a24;
      display: flex;
      align-items: center;
      justify-content: center;

    }
    .file_list_menu{
      max-width:180px;
    }
    .menu-item{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      span{
        font-size: 12px;
      }
    }
  }
  .box_top{
    width: 100%;
    height: 50px;
    margin-bottom: 3px;
  }
  /*pdf文件展示区*/
  .pdf-box {
    position: relative;
    .box {
      // border: 1px solid #333;
      box-sizing: border-box;
    }
    .select_seal_img{
      position: absolute;
      // width: 100px;
      // height: 100px;
      z-index: 999;
      /*关闭按钮*/
      .icon{
        position: absolute;
        right: -5px;
        top: -5px;
        z-index: 999;
        width: 20px;
        height: 20px;
      }
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  /*印章位置小点*/
  .pointer {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #333;
    position: absolute;
    z-index: 99;
  }
  /* 我的印章列表 */
  .popup_seal{
    width: 100%;
    /*height: 130px;*/
    padding: 8px 0;
    box-sizing: border-box;
    ::v-deep .van-popup__close-icon--top-right{
      top: 8px;
      right: 8px;
    }
    .my_seal_label{
      font-size: 18px;
      color: #333;
      width: 100%;
      box-sizing: border-box;
      padding: 0 30px;
      position: relative;
      margin-bottom: 8px;
      &::before{
        content: "";
        position: absolute;
        left: 10px;
        top: 50%;
        width: 5px;
        height: 80%;
        transform: translateY(-50%);
        border-radius: 8px;
        background-color: #42b983;
      }
    }
    .my_seal_list{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      /*justify-content: space-around;*/
      width: 100%;
      overflow-y: auto;
      height: 100px;
      /*position: fixed;*/
      /*bottom: 0;*/
      /*z-index: 999;*/
      /*left: 0;*/
      background-color: #fefefe;
      border-top: 1px solid #f4f4f4;
      box-sizing: border-box;
      .seal_box{
        width: 25%;
        height: 100%;
        box-sizing: border-box;
        border-right: 1px solid #f4f4f4;
        border-bottom: 1px solid #f4f4f4;
        display: flex;
        justify-content: center;
        align-items: center;
        &:nth-child(4n){
          border-right: none;
        }
        img{
          width: 80%;
          /*height: 90%;*/
        }
      }
    }
    .temp_seal_list{
      
      display: flex;
      align-items: center;
      padding: 10px;
      .van-button{
        margin-right: 10px;
      }
      .seal_box{
        position: relative;
        margin-right: 6px;
        width: 20%;
        height: 44px;
        border: 1px solid #f4f4f4;
        img{
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        i{
          position: absolute;
          right: 0;
          top: 0;
        }
      }
    }
	
  }
  .not-match-wrapper{
	color: #fff;
	background-color: #ff0000;
	border-radius: 10px;
	padding: 5px 9px;
  	position: fixed;
  	right: 2vw;
  	top: 10vh;
  	display: flex;
  	flex-direction: column;
  	align-items: center;
	i{
		font-size: 30px;
	}
  }
  .submit_btn{
    padding: 3px 8px;
    font-size: 13px;
    box-sizing: border-box;
    background-color: #42b983;
    color: #fff;
    border-radius: 8px;
  }
}
.popup_seal_type{
  ::v-deep .van-popup__close-icon--top-right{
      top: 8px;
      right: 8px;
    }
  .seal_type{
    display: flex;
    justify-content: space-around;
    font-size: 14px;
    &_item{
      display: flex;
      flex-direction: column;
      align-items: center;
      img{
        width:30px;
        height: 30px;
        margin-bottom: 6px;
      }

    }
  }
}


</style>
